export default "__VITE_ASSET__O$aT2b_j__"